import insertNode from './insertNode.mjs'

const getDefaultType = (map, node) => {
    const _n = map.nodeProxy(node)
    return _n.defaultChildType()
}

export const canInsertChild = () => defaultActions => {
    return function (node) {
        if (! this.permission.has('write')) {
            this.logger.error('没有权限', [node])
            return false
        }

        const _n = this.nodeProxy(node)

        if (! _n.canWriteTree()) {
            return false
        }

        return defaultActions.canInsertChild(node)
    }
}

export const appendChild = () => () => {
    return function (nodes) {
        return insertNode(
            this,
            nodes,
            this.appendChild.bind(this),
            getDefaultType
        )
    }
}

export const prependChild = () => () => {
    return function (nodes) {
        return insertNode(
            this,
            nodes,
            this.prependChild.bind(this),
            getDefaultType
        )
    }
}
